import * as React from "react";

function SvgComponent(
  props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>
) {
  return (
    <svg
      width={20}
      height={20}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.809 5.192a6.8 6.8 0 10-9.617 9.617 6.8 6.8 0 109.617-9.617zm-10.607-.99a8.2 8.2 0 0111.597 0 8.2 8.2 0 010 11.597 8.2 8.2 0 01-11.597 0 8.2 8.2 0 010-11.597zM8.05 7.5a.7.7 0 01.7-.7h3.75a.7.7 0 01.7.7v3.75a.7.7 0 11-1.4 0V9.19l-3.805 3.805a.7.7 0 11-.99-.99L10.81 8.2H8.75a.7.7 0 01-.7-.7z"
        fill={props.color ?? "#23262F"}
      />
    </svg>
  );
}

export default SvgComponent;
